import axios from 'axios'

// 创建带 baseURL 的 axios 实例（用于大多数 API 调用）
const api = axios.create({
    baseURL: '/api', // 使用代理配置的/api前缀
    timeout: 60000, // 将超时时间增加到60秒
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true // 添加凭据支持
})

// 创建不带 baseURL 的 axios 实例（用于 QuickResponse API 调用）
const apiWithoutBaseURL = axios.create({
    timeout: 120000, // 将超时时间增加到120秒，以处理大数据量加载
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true // 添加凭据支持
})

// 为 apiWithoutBaseURL 实例添加请求拦截器
apiWithoutBaseURL.interceptors.request.use(
    config => {
        // 添加CSRF token
        const csrftoken = getCookie('csrftoken')
        if (csrftoken) {
            config.headers['X-CSRFToken'] = csrftoken
        }

        // 如果有token也添加Authorization header
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Token ${token}`
        }

        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 为 apiWithoutBaseURL 实例添加响应拦截器，包含重试机制
apiWithoutBaseURL.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        return response
    },
    async error => {
        // 对响应错误做点什么
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 未授权，清除token并跳转到登录页
                    localStorage.removeItem('token')
                    break
                case 403:
                    // 禁止访问
                    console.error('访问被禁止')
                    break
                case 500:
                    // 服务器错误
                    console.error('服务器错误')
                    break
                default:
                    console.error('未知错误')
            }
        } else if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') {
            // 处理超时错误，尝试重试
            console.warn('请求超时，正在重试...');

            // 获取原始请求配置
            const config = error.config;

            // 如果没有retryCount属性，初始化为0
            if (!config.retryCount) {
                config.retryCount = 0;
            }

            // 如果重试次数小于3次，则进行重试
            if (config.retryCount < 3) {
                config.retryCount++;
                console.log(`重试第 ${config.retryCount} 次...`);

                // 延迟一段时间后重试，避免过于频繁的请求
                await new Promise(resolve => setTimeout(resolve, 2000 * config.retryCount));

                // 重新发起请求
                return apiWithoutBaseURL(config);
            }
        }
        return Promise.reject(error)
    }
)

// 请求拦截器
api.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Token ${token}`
        }

        // 添加CSRF token
        const csrftoken = getCookie('csrftoken')
        if (csrftoken) {
            config.headers['X-CSRFToken'] = csrftoken
        }

        return config
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 响应拦截器
api.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        return response
    },
    async error => {
        // 对响应错误做点什么
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 未授权，清除token并跳转到登录页
                    localStorage.removeItem('token')
                    // 这里可以使用Vue Router进行跳转
                    // router.push('/login')
                    break
                case 403:
                    // 禁止访问
                    console.error('访问被禁止')
                    break
                case 500:
                    // 服务器错误
                    console.error('服务器错误')
                    break
                default:
                    console.error('未知错误')
            }
        } else if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') {
            // 处理超时错误，尝试重试
            console.warn('请求超时，正在重试...');

            // 获取原始请求配置
            const config = error.config;

            // 如果没有retryCount属性，初始化为0
            if (!config.retryCount) {
                config.retryCount = 0;
            }

            // 如果重试次数小于3次，则进行重试
            if (config.retryCount < 3) {
                config.retryCount++;
                console.log(`重试第 ${config.retryCount} 次...`);

                // 延迟一段时间后重试，避免过于频繁的请求
                await new Promise(resolve => setTimeout(resolve, 2000 * config.retryCount));

                // 重新发起请求
                return api(config);
            }
        }
        return Promise.reject(error)
    }
)

// 获取cookie中的csrftoken
function getCookie(name) {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                break
            }
        }
    }
    return cookieValue
}

export default api
export { apiWithoutBaseURL }